import { useUnit } from 'effector-react';
import {
  Button,
  Modal,
  Popover,
  Select,
  Skeleton,
  Table,
  Typography,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
  $bizDistrictModalData,
  $bizDistrictModalState,
  $bizPollsStatsModalData,
  BizPollsStatsModalGate,
  getBizModalPollsStatsFx,
  resetDistrictModalEv,
  setBizPollsStatsModalEv,
  setDistrictModalEv,
} from '../../../../models/overviewModel/index.js';
import BarChart from '../../../../components/BarChart/BarChart.jsx';
import ColumnChart from '../../../../components/ColumnChart/ColumnChart.jsx';
import BizPollsStatsModal from './BizPollsStatsModal.jsx';

const infoDict = {
  'Деятельность МИО в привл инв': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка деятельности акимата по привлечению инвестиций и сопровождению
          инвестиционных проектов в населенном пункте
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>
          не заинтересован в привлечении инвестиций и никак не сопровождает
          инвестпроекты
        </li>
        <li>
          частично заинтересован в привлечении инвестиций, чаще не прилагает
          усилий к сопровождению инвестпроектов
        </li>
        <li>
          заинтересован в привлечении инвестиций, но не всегда прилагает усилия
          к сопровождению инвестпроектов
        </li>
        <li>
          заинтересован в привлечении инвестиций и максимально прилагает усилия
          к сопровождению инвестпроектов
        </li>
      </ol>
    </div>
  ),
  'Привлечение инвестиций': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка деятельности акимата по привлечению инвестиций и сопровождению
          инвестиционных проектов в населенном пункте
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>
          не заинтересован в привлечении инвестиций и никак не сопровождает
          инвестпроекты
        </li>
        <li>
          частично заинтересован в привлечении инвестиций, чаще не прилагает
          усилий к сопровождению инвестпроектов
        </li>
        <li>
          заинтересован в привлечении инвестиций, но не всегда прилагает усилия
          к сопровождению инвестпроектов
        </li>
        <li>
          заинтересован в привлечении инвестиций и максимально прилагает усилия
          к сопровождению инвестпроектов
        </li>
      </ol>
    </div>
  ),
  'Открытость акимата': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка насколько акимат населенного пункта (района/города) открыт для
          обсуждения бизнеса:
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>закрыт для обсуждения проблем и не приходил</li>
        <li>
          частично открыт для обсуждения проблем, приходил для формальности
        </li>
        <li>
          открыт для обсуждения проблем, частично рассказал о мерах поддержки и
          получения госуслуг
        </li>
        <li>
          открыт для обсуждения проблем и приходил, рассказал о мерах поддержки
          и получения госуслуг
        </li>
      </ol>
    </div>
  ),
  'Эффективность акимата': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка насколько акимат населенного пункта (района/города) содействует
          решению проблем бизнеса:
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>не отвечает на мои запросы</li>
        <li>редко прилагает усилия решить мои проблемы</li>
        <li>чаще прилагает усилия решить мои проблемы</li>
        <li>максимально прилагает усилия решить мои проблемы</li>
      </ol>
    </div>
  ),

  'Уровень коррупции': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка уровеня распространенности коррупции или неформальных способов
          налаживания взаимоотношений с представителями госорганов в населенном
          пункте:
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>Всегда</li>
        <li>Часто</li>
        <li>Редко</li>
        <li>Нет коррупции</li>
      </ol>
    </div>
  ),
  'Доступность мер господдержки': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка доступности (наличие информации) и эффективности (полезность)
          мер государственной поддержки для бизнеса (финансовые и нефинансовые
          меры поддержки), реализуемых в населенном пункте
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>Низкая</li>
        <li>Средняя</li>
        <li>Выше среднего</li>
        <li>Высокая</li>
      </ol>
    </div>
  ),
  'Доступность мер ГП': (
    <div style={{ display: 'inline-block' }}>
      <Typography.Paragraph>
        <strong>
          Оценка доступности (наличие информации) и эффективности (полезность)
          мер государственной поддержки для бизнеса (финансовые и нефинансовые
          меры поддержки), реализуемых в населенном пункте
        </strong>
      </Typography.Paragraph>
      <ol>
        <li>Низкая</li>
        <li>Средняя</li>
        <li>Выше среднего</li>
        <li>Высокая</li>
      </ol>
    </div>
  ),
};

export default function BizDistrictModal() {
  const changeModalState = useUnit(setDistrictModalEv);
  const { open, type, granularity, region_id, selectedQuarter, selectedYear } =
    useUnit($bizDistrictModalState);
  const { title, table, charts, years } = useUnit($bizDistrictModalData);

  const loading = useUnit(getBizModalPollsStatsFx.pending);

  const yearsSelect = years.map((y) => ({ value: y, label: y }));

  const setPollsStatsModal = useUnit(setBizPollsStatsModalEv);

  const pollsData = useUnit($bizPollsStatsModalData);

  const close = useUnit(resetDistrictModalEv);
  const { t } = useTranslation();

  const allCategories = new Set();
  table.forEach((row) => {
    if (row.categories) {
      Object.keys(row.categories).forEach((cat) => allCategories.add(cat));
    }
  });

  const childrenCols = Array.from(allCategories).map((category) => ({
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {/*{t(`dashboard.business_climate.${category}`)}*/}
        {category}
        <Popover
          content={infoDict[category]}
          style={{ maxWidth: 300, maxHeight: 300, overflow: 'auto' }}
        >
          <InfoCircleOutlined />
        </Popover>
      </div>
    ),
    dataIndex: ['categories', category],
    key: category,
    sorter: (a, b) =>
      (a.categories[category] ?? -1) - (b.categories[category] ?? -1),
    render: (value) => (value ? value.toFixed(2) : 'Нет данных'),
  }));

  const columns = [
    {
      title: '№',
      key: 'number',
      render: (_, __, idx) => idx + 1,
    },
    {
      title: t('dashboard.business_climate.Название'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('dashboard.business_climate.Общий рейтинг'),
      dataIndex: 'avg',
      sorter: (a, b) => {
        const av = Number.isNaN(a.avg) ? -Infinity : a.avg;
        const bv = Number.isNaN(b.avg) ? -Infinity : b.avg;
        return av - bv;
      },
      key: 'avg',
      render: (avg, idx) => {
        // const sum = Object.values(idx.categories).reduce(
        //   (total, num) => total + parseFloat(num),
        //   0
        // );
        // const result = sum / 4;
        // return result.toFixed(2);
        // isNaN(avg) ? 'Нет данных': +avg.toFixed(2),
        return isNaN(avg)
          ? t('dashboard.business_climate.Нет данных')
          : avg.toFixed(2);
      },
    },
    {
      title: t('dashboard.business_climate.В том числе'),
      key: 'categories',
      children: childrenCols,
    },
  ];

  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      onCancel={() => close()}
      width="90vw"
    >
      <BizPollsStatsModalGate
        type={type === 'business_inspections' ? 'малый' : 'средний'}
        region_id={region_id}
        quarter={selectedQuarter}
        year={selectedYear}
      />
      <BizPollsStatsModal />
      {loading ? (
        <Skeleton loading={true} />
      ) : (
        <>
          <div style={{ display: 'flex', gap: 16 }}>
            {granularity === 'year' && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                  marginBottom: 8,
                }}
              >
                <span>Год</span>
                <Select
                  options={yearsSelect}
                  value={selectedYear}
                  onChange={(v) => changeModalState({ selectedYear: v })}
                />
              </div>
            )}
            {granularity === 'quarter' && (
              <>
                <div
                  style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                  <span>Год</span>
                  <Select
                    options={yearsSelect}
                    value={selectedYear}
                    onChange={(v) => changeModalState({ selectedYear: v })}
                  />
                </div>
                <div
                  style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                  <span>Квартал</span>
                  <Select
                    options={[
                      { value: 1, label: 'I' },
                      { value: 2, label: 'II' },
                      {
                        value: 3,
                        label: 'III',
                      },
                      // { value: 4, label: 'IV' },
                    ]}
                    value={selectedQuarter}
                    onChange={(v) => changeModalState({ selectedQuarter: v })}
                  />
                </div>
              </>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              maxHeight: '35vh',
            }}
          >
            {granularity === 'quarter' && (
              <ColumnChart
                style={{ width: 400 }}
                data={charts.column}
                xAlias="Квартал"
                yAlias="Сред. значение"
                title={t('dashboard.business_climate.Период')}
                scroll={!!charts.column.length > 8}
              />
            )}
            <div
              style={{ maxWidth: '40%', maxHeight: '25vh', overflow: 'auto' }}
            >
              <Typography.Paragraph>
                <strong>{t('dashboard.business_climate.biz_desc_1')}</strong>
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_2')}{' '}
                <strong>{t('dashboard.business_climate.biz_desc_2.1')}</strong>
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_3')}{' '}
                <strong>{t('dashboard.business_climate.biz_desc_3.1')}</strong>{' '}
                {t('dashboard.business_climate.biz_desc_3.2')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                <strong> {t('dashboard.business_climate.biz_desc_4')}</strong>{' '}
                {t('dashboard.business_climate.biz_desc_4.1')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_5')}{' '}
              </Typography.Paragraph>
              <Typography.Paragraph>
                <strong>{t('dashboard.business_climate.biz_desc_6')}</strong>{' '}
                {t('dashboard.business_climate.biz_desc_6.1')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                <strong>{t('dashboard.business_climate.biz_desc_7')}</strong>
                {t('dashboard.business_climate.biz_desc_7.1')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_8')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_9')}
              </Typography.Paragraph>
              <Typography.Paragraph>
                {t('dashboard.business_climate.biz_desc_10')}
              </Typography.Paragraph>
            </div>
            <BarChart
              data={charts.bar.map((item) => {
                return {
                  ...item,
                  // category: t(`dashboard.business_climate.${item.category}`),
                  category: item.category,
                };
              })}
              xAlias="Категория"
              yAlias="Сред. значение"
              title={t('dashboard.business_climate.Показатели')}
              style={{ width: 400 }}
              concatLabel
              scroll={false}
              cutValues={false}
            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: 8,
              alignItems: 'center',
              marginBottom: 16,
            }}
          >
            <Typography.Title
              level={4}
              style={{ margin: 0, display: 'inline-block' }}
            >
              {t('dashboard.business_climate.Количество респондентов')} -{' '}
              {pollsData.gov_id_count}
            </Typography.Title>
            <Button type="primary" onClick={() => setPollsStatsModal()}>
              {t('dashboard.business_climate.Детали')}
            </Button>
          </div>
          <Table
            dataSource={table}
            pagination={false}
            columns={columns}
            bordered
            style={{ width: '100%', overflow: 'auto' }}
          />
        </>
      )}
    </Modal>
  );
}
